import { useMemo } from 'react';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import { useWatchHistoryStore } from '@jwp/ott-common/src/stores/WatchHistoryStore';
import { VideoProgressMinMax } from '@jwp/ott-common/src/constants';

import { useWatchHistoryListener } from './useWatchHistoryListener';

// How many seconds should be subtracted from the stored start time to ensure the viewer doesn't miss any progress
const START_OFFSET = 5;

export const useWatchHistory = (item: PlaylistItem, seriesItem?: PlaylistItem) => {
  // config
  const { features } = useConfigStore((s) => s.config);
  const continueWatchingList = features?.continueWatchingList;
  const watchHistoryEnabled = !!continueWatchingList;

  // watch history listener
  const { saveWatchProgress, handleTimeUpdate } = useWatchHistoryListener(item, seriesItem);

  // watch History
  const watchHistoryItem = useWatchHistoryStore((state) => (!!item && watchHistoryEnabled ? state.getItem(item) : undefined));

  // calculate the `startTime` of the current item based on the watch progress
  const startTime = useMemo(() => {
    const videoProgress = watchHistoryItem?.progress;

    if (videoProgress && videoProgress > VideoProgressMinMax.Min && videoProgress < VideoProgressMinMax.Max) {
      return Math.max(0, videoProgress * item.duration - START_OFFSET);
    }

    // start at the beginning of the video (only for VOD content)
    return 0;
  }, [item.duration, watchHistoryItem?.progress]);

  return { startTime, saveWatchProgress, handleTimeUpdate, watchHistoryEnabled };
};
